import React from 'react'
import { ThemeProvider as EmotionThemeProvider } from 'emotion-theming'

import { useCanary } from '@bill/canary.react'
import GlobalThemeProvider from '@divvy-web/skylab.globalthemeprovider'
import { brands, fallbackBrand } from '@divvy-web/skylab.themes-emotion'

const ThemeProvider = ({ children }: React.PropsWithChildren) => {
  const showAireTheme = useCanary('show-skylab-aire-theme')
  const themeName = showAireTheme ? 'aire' : 'bill'
  const theme = brands[themeName] || fallbackBrand

  return (
    <GlobalThemeProvider
      applyResetCss
      applyTokensToDocument
      theme={themeName}
    >
      <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>
    </GlobalThemeProvider>
  )
}

export default ThemeProvider
